// extracted by mini-css-extract-plugin
export default {"zoomModal":"l1-z","image":"m1-z","button":"n1-z","isOverlayShown":"o1-z"};